<template>
    <main>
        <crumbs :crumbs="crumbs"></crumbs>
        <div class="wrap">
            <div class="form-box">
                <div class="title-box">
                    <div class="title">联系我们</div>
                    <div class="line"></div>
                </div>
                <div class="form">
                    <div class="left item">
                        <div class="tit"><i>*</i>姓名</div>
                        <div class="input" :class="[error.username ? 'error' :'']"><input type="text" @blur="validate('username')" placeholder="请输入您的姓名" v-model="form.username"></div>
                        <div class="validate">{{error.username}}</div>
                    </div>
                    <div class="left item">
                        <div class="tit"><i>*</i>手机号</div>
                        <div class="input" :class="[error.phone ? 'error' :'']"><input type="text" @blur="validate('phone')" placeholder="请输入您的手机号" v-model="form.phone"></div>
                        <div class="validate">{{error.phone}}</div>
                    </div>
                    <div class="left item">
                        <div class="tit"><i>*</i>邮箱</div>
                        <div class="input" :class="[error.email ? 'error' :'']"><input type="text" @blur="validate('email')" placeholder="请输入您的邮箱" v-model="form.email"></div>
                        <div class="validate">{{error.email}}</div>
                    </div>
                    <div class="left item">
                        <div class="tit"><i>*</i>地址</div>
                        <div class="input" :class="[error.address ? 'error' :'']"><input type="text" @blur="validate('address')" placeholder="请输入您的地址" v-model="form.address"></div>
                        <div class="validate">{{error.address}}</div>
                    </div>
                    <div class="left item">
                        <div class="tit"><i>*</i>公司</div>
                        <div class="input" :class="[error.company ? 'error' :'']"><input type="text" @blur="validate('company')" placeholder="请输入您的公司" v-model="form.company"></div>
                        <div class="validate">{{error.company}}</div>
                    </div>
                    <div class="left item">
                        <div class="tit"><i>*</i>部门</div>
                        <div class="input" :class="[error.department ? 'error' :'']"><input type="text" @blur="validate('department')" placeholder="请输入您的部门" v-model="form.department"></div>
                        <div class="validate">{{error.department}}</div>
                    </div>
                    <div class="left item">
                        <div class="tit"><i>*</i>工作角色</div>
                        <div class="input" :class="[error.job ? 'error' :'']"><input type="text" @blur="validate('job')" placeholder="请输入您的工作角色" v-model="form.job"></div>
                        <div class="validate">{{error.job}}</div>
                    </div>
                    <div class="left item">
                        <div class="tit"><i>*</i>国家/地区</div>
                        <div class="input" :class="[error.country ? 'error' :'']"><input type="text" @blur="validate('country')" placeholder="请输入您所在的国家/地区" v-model="form.country"></div>
                        <div class="validate">{{error.country}}</div>
                    </div>
                    <div class="left item item-l">
                        <div class="tit">详细信息</div>
                        <div class="input">
                            <textarea name="" id="" cols="30" rows="10" placeholder="请输入您要咨询详细信息，如产品名称、颜色等" v-model="form.message"></textarea>
                        </div>
                    </div>
                </div>
                <div class="rule-box item-select">
                    <div class="tit">
                        <label><input type="checkbox" v-model="form.agree_contact2" true-value="1" false-value="2" name="agree"><i class="i"></i>
                            <span style="font-size: 14px;">我了解并同意以下内容：戴尔按照<a target="_blank" rel="noopener noreferrer" href="https://www.dell.com/zh-cn/lp/legal/policies-privacy" style="color: #007db8;">《隐私声明》</a>所述，根据《个人信息保护法》的规定，将本人个人信息传输、存储至戴尔美国总部进行处理。要详细了解戴尔如何使用、共享和保护您的个人数据，请参阅我们的 <a target="_blank" rel="noopener noreferrer" href="https://www.dell.com/zh-cn/lp/legal/policies-privacy" style="color: #007db8;">隐私声明</a>。<br><div class="privacy-statement-text" style="margin-top: 10px;">单击"提交"，即表示您同意 <a target="_blank" rel="noopener noreferrer" href="https://investors.delltechnologies.com/node/11831/html" style="color: #007db8;">Dell Technologies 及其公司集团</a>（简称"戴尔"）通过电子邮件、电话或短信与您保持联系。戴尔及其销售代表将向您提供有关产品、服务、解决方案、专享优惠和特别活动的最新信息。有关信息处理方式的更多详细信息，请参见我们的 <a target="_blank" rel="noopener noreferrer" href="https://www.dell.com/zh-cn/lp/legal/policies-privacy" style="color: #007db8;">隐私声明</a>。您可以随时取消订阅。</div></span>
                        </label>
                    </div>
                    <div class="validate">{{error.agree_contact2}}</div>
                </div>
                <div class="submit">
                    <div class="btn" @click="submit">提交</div>
                </div>
            </div>
            <div class="address-box">
                <div class="title">联系地址</div>
                <div class="line"></div>
                <div class="list">
                    <div class="left item">
                        <div class="middle">
                            <div class="icon icon-logo"><img :src="require('@/assets/image/41.png')" alt=""></div>
                            <div class="tit">{{adv1.title}}</div>
                            <div class="address">{{adv1.min_title}}</div>
                        </div>
                    </div>
                    <div class="left item">
                        <div class="middle">
                            <div class="icon icon-tel"><img :src="require('@/assets/image/42.png')" alt=""></div>
                            <div class="tit">{{adv2.title}}</div>
                            <div class="address"><a :href="'tel:'+adv2.min_title">{{adv2.min_title}}</a></div>
                        </div>
                    </div>
                </div>
            </div>
			<sponsor/>
        </div>
    </main>
</template>

<script>
    import Crumbs from "../../../components/pc/Crumbs";
	import Sponsor from "@/components/pc/Sponsor.vue";
    export default {
        name: 'dell',
        data() {
            return {
                query:"",
                form:{
                    agree_contact2:2
                },
                error:{},
                adv1:{},
                adv2:{}
            }
        },
        components:{
            Crumbs,Sponsor
        },
        computed:{
            crumbs() {
				return {title:"联系戴尔",min_title:"Contact dell"}
            },
        },
        methods: {
            validate(field){
                var message = "";
                switch (field) {
                    case 'username':
                        if(!this.form.username){
                            message = "请输入您的姓名";
                        }else{
                            message = "";
                        }
                        break;
                    case 'phone':
                        if(!this.form.phone){
                            message = "请输入手机号";
                        }else if(this.isCn() && !this.tool.type.checkStr(this.form.phone,'phone') ){
                            message = "手机号格式不正确";
                        }else{
                            message = "";
                        }
                        break;
                    case 'email':
                        if(!this.form.email){
                            message = "请输入您的邮箱";
                        }else if(!this.tool.type.checkStr(this.form.email,'email') ){
                            message = "邮箱格式不正确";
                        }else{
                            message = "";
                        }
                        break;
                    case 'address':
                        if(!this.form.address){
                            message = "请输入您的地址";
                        }else{
                            message = "";
                        }
                        break;
                    case 'company':
                        if(!this.form.company){
                            message = "请输入您的公司";
                        }else{
                            message = "";
                        }
                        break;
                    case 'department':
                        if(!this.form.department){
                            message = "请输入您的部门";
                        }else{
                            message = "";
                        }
                        break;
                    case 'job':
                        if(!this.form.job){
                            message = "请输入您的工作角色";
                        }else{
                            message = "";
                        }
                        break;
                    case 'country':
                        if(!this.form.country){
                            message = "请输入您所在的国家/地区";
                        }else{
                            message = "";
                        }
                        break;
                    case 'agree_contact2':
                        if(this.form.agree_contact2 != 1 && this.form.agree_contact2 != '1'){
                            message = "请先阅读并同意戴尔隐私声明和销售条款";
                        }else{
                            message = "";
                        }
                        break;
                    default:
                        break;

                }
                this.setError(field,message);
                return message ? false : true;
            },
            setError(name,message =""){
                this.error[name] = message;
                this.$forceUpdate();
            },
            validateAll(){
                var username = this.validate("username");
                var phone = this.validate("phone");
                var email = this.validate("email");
                var address = this.validate("address");
                var company = this.validate("company");
                var department = this.validate("department");
                var job = this.validate("job");
                var country = this.validate("country");
                var agree_contact2 = this.validate("agree_contact2");
                if(!username || !phone || !email || !address || !company || !department || !job || !country || !agree_contact2 ){
                    return false;
                }else{
                    return  true;
                }
            },
            submit(){
                var res = this.validateAll();
                if(!res){return false;}
                this.form.agree_contact = this.form.agree_contact2;

                gio('track', 'DTF2021_contactSubmit', {
                    //'userName':this.form.username,
                    'phoneNumber':this.util.encryptPhone(this.form.phone),
                    //'company' : this.form.company,
                    //'email' :this.form.email,
                });

                this.http.request({
                    api:"feedback/submit",
                    data:this.form,
                    loading:true,
                    success:(res)=>{
                        this.$toast.success("提交成功");
                        this.form = {};
                    }
                })
            },
            isCn(){
                return true;
            },
            setForm(){
                var user = this.$store.state.user_info;
                this.form.username = user.username;
                this.form.phone = user.phone;
                this.form.email = user.email;
                this.form.company = user.company;
                this.form.department = user.department;
                this.form.job = user.job;
                this.$forceUpdate();
            }
        },
        mounted() {
            this.query = this.$route.query;
            this.setForm();
            this.util.showBottom(true);
        }
    }
</script>

<style lang="scss" type="text/scss" scoped>
    .wrap{padding-top: 20px;padding-bottom: 50px;
        .form-box{background: #fff;width: 920px;margin: 0 auto;padding: 30px 140px;
            .title{font-size: 22px;}
            .line{width: 40px;height:5px;background: #1D56C0;margin-top: 5px;}
            .form{margin-top: 20px;overflow: hidden;
                .item{width: 410px;
                    .tit{font-size: 16px;color:#565656;
                        i{color: red;margin-right: 2px;}
                    }
                    .input{width: 400px;margin-top:5px;
                        input{display: block;width:380px;height:45px;border: 1px solid #d4d4d4;line-height: 45px; padding: 0 10px;background: #fff;font-size: 16px;}
                        textarea{width: 891px;height:90px;border: 1px solid #d4d4d4;padding: 10px;}
                    }
                    .input.error{
                        input{border-color: red;}
                    }
                    .validate{height:30px;line-height: 30px;font-size:14px;color:red;}
                }
                .item:nth-child(2n){float: right;}
            }
            .check-box{margin: 25px auto;
                .tit{font-size: 15px;line-height: 21px;
                    .red{color:red;margin-right: 2px;}
                }
                .check{overflow: hidden;margin-top: 10px;
                    label{margin-right: 50px;height:30px;line-height: 30px;cursor: pointer;overflow: hidden;display: block;float: left;
                        input{margin-right:10px;width: 18px;height:18px;float: left;margin-top: 5px;display: none;}
                        input[type=radio]+i{display: block;float: left; width: 30px;height:30px;background: url("~@/assets/image/a2.png") no-repeat center center;background-size: 22px;transition: all .3s ease;}
                        input[type=radio]:checked+i{background: url("~@/assets/image/2024/r02.png") no-repeat center center;background-size: 22px;transition: all .3s ease;}
                        span{display: block;float: left;}
                    }
                }
            }
            .rule-box{margin: 25px auto;
                .tit{font-size: 15px;line-height: 21px;overflow: hidden;
                    input{display: none;}
                    span{display: block;float: left;width: calc(100% - 40px);}
                    input[type=checkbox]+.i{display: block;float: left;width: 30px;height: 30px;background: url("~@/assets/image/a4.png") no-repeat center center;background-size: 22px;transition: all .3s ease;}
                    input[type=checkbox]:checked+.i{background: url("~@/assets/image/2024/check1.png") no-repeat center center;background-size: 22px;transition: all .3s ease;}
                }
                .validate{clear: both;height:30px;line-height: 30px;font-size:14px;color:red;padding-left: 30px;}
            }
            .submit{margin-top: 20px;
                .btn{width: 210px;height:55px;border-radius: 2px;text-align: center;line-height: 55px;color:#fff;background: #1D56C0;font-size: 20px;cursor: pointer;transition: all .3s ease;}
                .btn:hover{color: #fff;transition: all .3s ease;}
            }
        }
        .address-box{background: #fff;width: 920px;margin: 20px auto 0;padding: 30px 140px;display: none;
            .title{font-size: 22px;}
            .line{width: 40px;height:5px;background: #1D56C0;margin-top: 5px;}
            .list{overflow: hidden;margin-top: 20px;
                .item{width: 440px;height:200px;border: 1px solid #f1f1f1;
                    .middle{width: 440px;height:200px;
                        .icon{text-align: center;
                            img{max-height:50px;}
                        }
                        .tit{margin-top: 20px;}
                        .tit,.address{font-size: 14px;text-align: center;
                            a{color: #000;}
                        }
                    }
                }
            }
        }
    }
    
    .link-blue {
        color: #0176ce !important;
        text-decoration: underline;
    }
</style>

